import { shiftList } from "constants/shift";

const initialState = {
  shiftList: {},
};

const shift = (state = initialState, action) => {
  switch (action.type) {
    case shiftList:
      return { ...state, shiftList: action.payload };
    default:
      return state;
  }
};

export default shift;